interface FilterOption {
  value: string
  label: string
  count?: number
  countColor?: 'amber' | 'red' | 'gray' | 'primary' | 'blue'
}

interface FilterTabsProps {
  options: FilterOption[]
  value: string
  onChange: (value: string) => void
}

export function FilterTabs({ options, value, onChange }: FilterTabsProps) {
  const getCountColor = (color?: FilterOption['countColor']) => {
    switch (color) {
      case 'amber':
        return 'text-amber-600'
      case 'red':
        return 'text-red-600'
      case 'primary':
        return 'text-primary-600'
      case 'blue':
        return 'text-blue-600'
      case 'gray':
      default:
        return 'text-gray-600'
    }
  }

  return (
    <div className="mb-3 sm:mb-6">
      <div role="group" aria-label="Filter results" className="flex flex-wrap gap-2">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            aria-pressed={value === option.value}
            onClick={() => onChange(option.value)}
            className={`inline-flex min-h-11 items-center justify-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
              value === option.value
                ? 'border-gray-900 bg-gray-900 text-white'
                : 'border-gray-200 bg-white text-gray-700 hover:border-gray-400 hover:bg-gray-50'
            }`}
          >
            <span>{option.label}</span>
            {option.count !== undefined && (
              <span
                className={`min-w-6 rounded-full px-1.5 py-0.5 text-xs font-semibold tabular-nums ${
                  value === option.value ? 'bg-white/15 text-white' : `bg-gray-50 ${getCountColor(option.countColor)}`
                }`}
              >
                {option.count}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  )
}
